import { Button, Divider } from 'antd'
import { createStyles } from 'antd-style'

import { UserAgreement } from '@eastcoal/auth/components/UserAgreement'
import { useNavigate } from '@eastcoal/router/exports/react-router'

import { LoginType } from '../../enums/LoginType'
import { useLoginStore } from '../../hooks/useStore'
import { navigateWithTarget } from '../../utils/navigateWithTarget'

const useStyles = createStyles(({ prefixCls, token }) => ({
  footer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    paddingBlockStart: token.padding,
    paddingBlockEnd: token.paddingMD,
    fontSize: token.fontSizeSM,
    [`& a`]: {
      fontSize: token.fontSizeSM
    }
  },
  userAgreement: {
    paddingBlockEnd: token.padding
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    [`& .${prefixCls}-btn`]: {
      padding: 0,
      height: 'auto',
      fontSize: token.fontSizeSM
    }
  }
}))

export const LoginFooter = () => {
  const { loginType } = useLoginStore()
  const navigate = useNavigate()

  const handleSwitchLoginType = () => {
    navigateWithTarget(
      navigate,
      `#${loginType === LoginType.WECHAT ? LoginType.SMS : LoginType.WECHAT}`
    )
  }

  const handleGoToRegister = () => {
    navigateWithTarget(navigate, '/register')
  }

  const { styles } = useStyles()

  return (
    <div className={styles.footer}>
      <div>
        <span>登录即表示您已阅读并同意</span>
        <UserAgreement className={styles.userAgreement} />
      </div>
      <div className={styles.actions}>
        <Button type='text' onClick={handleSwitchLoginType}>
          切换{loginType === LoginType.WECHAT ? '手机' : '扫码'}登录
        </Button>
        <Divider orientation='vertical' />
        <Button type='link' onClick={handleGoToRegister}>
          前往注册
        </Button>
      </div>
    </div>
  )
}
